export * from './wikis.service';
